import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
import { useForm, Controller } from 'react-hook-form';
import { getHarvestData, updateHarvest } from '../../services/Harvest/harvestService';
import ErrorModal from '../Modals/ErrorModal';
import SuccessModal from '../Modals/SuccessModal';
import DateInput from '../Utils/DateInput';
import InputField from '../Utils/InputField';
import { convertDateToISO } from '../Utils/utils';
import { usePermissions } from '../../hooks/usePermissions';

const EditHarvestModal = ({ show, handleClose, harvest, refreshHarvests }) => {
  const { register, handleSubmit, setValue, control, formState: { errors }, reset, watch } = useForm();
  const { hasPermission } = usePermissions();
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const canDelete = hasPermission('harvestDelete');

  useEffect(() => {
    const fetchHarvestData = async () => {
      try {
        if (harvest?.id) {
          const data = await getHarvestData(harvest.id);
          setValue('oldId', data?.oldId);
          setValue('description', data.description);
          setValue('startDate', data.startDate);
          setValue('endDate', data.endDate);
          setValue('active', data.active);
        }
      } catch (error) {
        setErrorMessage(error.message || 'Erro ao buscar dados da safra.');
        setShowErrorModal(true);
      }
    };

    if (show && harvest) {
      fetchHarvestData();
    } else if (!show) {
      reset();
    }
  }, [show, harvest, setValue, reset]);

  const onSubmit = async (data) => {
    
    const payload = {
      ...data,
      startDate: data.startDate.includes('/') ? convertDateToISO(data.startDate) : data.startDate,
      endDate: data.endDate.includes('/') ? convertDateToISO(data.endDate) : data.endDate,
      active: data.active
    };

    try {
      await updateHarvest(harvest.id, payload);
      setSuccessMessage('Safra atualizada com sucesso!');
      setShowSuccessModal(true);
      reset();
    } catch (error) {
      setErrorMessage(error.message || 'Erro ao atualizar colheita.');
      setShowErrorModal(true);
    }
  };

  const handleCloseErrorModal = () => setShowErrorModal(false);
  const handleCloseSuccessModal = () => {
    setShowSuccessModal(false);
    refreshHarvests();
    handleClose();
  };

  return (
    <>
      <Modal show={show} onHide={handleClose} centered backdrop="static" keyboard={false} size="md">
        <Modal.Header closeButton>
          <Modal.Title>Editar Safra</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Row>
              <Col md={12}>
                <InputField
                  label="Descrição"
                  name="description"
                  placeholder="Digite a descrição"
                  register={register}
                  errors={errors}
                  rules={{ required: 'Descrição é obrigatória' }}
                />
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <Controller
                  name="startDate"
                  control={control}
                  render={({ field, fieldState }) => (
                    <DateInput
                      isEditing = { true }
                      label="Data de Início"
                      value={watch('startDate')}
                      onChange={field.onChange}
                      error={fieldState.error}
                      placeholder="__/__/____"
                    />
                  )}
                  rules={{
                    required: 'Data de início é obrigatória'
                  }}
                />
              </Col>
              <Col md={6}>
                <Controller
                  name="endDate"
                  control={control}
                  render={({ field, fieldState }) => (
                    <DateInput
                      isEditing = { true }
                      label="Data de Fim"
                      value={watch('endDate')}
                      onChange={field.onChange}
                      error={fieldState.error}
                      placeholder="__/__/____"
                    />
                  )}
                  rules={{
                    required: 'Data de fim é obrigatória'
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <Form.Check
                  type="checkbox"
                  label="Ativa"
                  {...register('active')}
                  defaultChecked={!!watch('active')}
                  disabled={!canDelete}
                />
              </Col>
            </Row>
            <Button variant="primary" className="button-custom w-100 mt-3" type="submit">
              Atualizar
            </Button>
          </Form>
        </Modal.Body>
      </Modal>

      <ErrorModal
        show={showErrorModal}
        handleClose={handleCloseErrorModal}
        errorMessage={errorMessage}
      />

      <SuccessModal
        show={showSuccessModal}
        handleClose={handleCloseSuccessModal}
        successMessage={successMessage}
      />
    </>
  );
};

export default EditHarvestModal;